import { Grid, Paper, Typography } from '@material-ui/core'
import { CustomFileDetailTable } from '../../../components/file_upload'
import { darkGrey } from '../utils'

const DocsSharedWithPresta = ({ record }) => {
  if (!record || record.fwc?.files_prestas?.length == 0) return null
  return (
    <Grid container justifyContent="center">
      <Grid
        item
        xs={11}
        md={6}
        style={{
          maxWidth: 'unset',
          flexBasis: 'unset',
          width: '100%',
        }}
      >
        <Paper>
          <Grid>
            <Typography
              variant="h5"
              style={{
                color: darkGrey,
                padding: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                cursor: 'pointer',
              }}
            >
              <p style={{ margin: 0 }}>Pièces jointes</p>
            </Typography>
          </Grid>
          <Grid item style={{ padding: '16px' }} fullWidth>
            {record.fwc.files_prestas &&
              record.fwc.files_prestas.length > 0 && (
                <CustomFileDetailTable
                  rows={record.fwc.files_prestas.map(
                    ({ url, purpose, category, type }) => ({
                      purpose,
                      category,
                      type,
                      preview_document: url,
                      url,
                    })
                  )}
                />
              )}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default DocsSharedWithPresta
